import React from "react";
import { ErrorMessage } from "@hookform/error-message";
import { DocumentIcon } from "../../../icons/DocumentIcon";

type FileUploaderProps = {
  name: string;
  type: string;
  change: (e: React.ChangeEvent<any>) => void;
  file: any;
  label?: string;
  required: boolean;
  accept: string;
  register: any;
  errors: any;
};
const FileUploader = ({
  name,
  type,
  change,
  file,
  label,
  required,
  accept,
  register,
  errors,
}: FileUploaderProps) => {
  const styles = {
    container: {
      width: "100%",
      border: `1px solid #4C5C6D`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "10px",
      borderRadius: "10px",
      padding: "20px 0 20px 0",
    },
    wrapper: {
      borderRadius: "10px",
      border: "1px dashed",
      height: "200px",
      width: "100%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px",
      marginBottom: "10px",
    },
    flex: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
    },
    input: {
      height: "100%",
      width: "100%",
      cursor: "pointer",
      opacity: 0,
    },
    fileView: {
      border: "1px solid",
      height: "80%",
      width: "80%",
    },
    fileName: {
      maxWidth: "90%",
      overflow: "hidden",
    },
    error: {
      color: "red",
      fontSize: "10px",
      margin: 0,
      padding: 0,
    },
    label: {
      fontSize: "15px",
      fontWeight: 900,
      marginLeft: "50px",
      marginRight: "10px",
      width: "50%",
    },
    col: {
      display: "flex",
      justifyContent: "center",
      height: "100%",
      width: "50%",
      alignItems: "center",
      marginRight: "20px",
    },
    errorDiv: {
      marginBottom: "20px",
    },
  };

  return (
    <>
      <div style={styles.container}>
        <label style={styles.label}>{label}</label>
        <div style={{ ...styles.col, flexDirection: "column" }}>
          <div
            style={{
              ...styles.wrapper,
              flexDirection: "column",
              position: "relative",
            }}
          >
            <div style={styles.flex}>
              {file ? (
                <div style={{ ...styles.flex, ...styles.fileView }}>
                  <p style={styles.fileName}>{file.name}</p>
                </div>
              ) : (
                <div>
                  <DocumentIcon />
                </div>
              )}
            </div>
            <input
              type={type}
              {...register(name, {
                required: required ? `${label} is required` : false,
                onChange: (e: any) => change(e),
              })}
              accept={accept}
              style={{ ...styles.input, position: "absolute" }}
            />
          </div>
        </div>
      </div>
      <div style={styles.errorDiv}>
        <ErrorMessage
          errors={errors}
          name={name}
          as="span"
          className="error-form"
        />
      </div>
    </>
  );
};

export default FileUploader;
